export function InfoLinks() {
  return (
    <section class="info-links">
      <a
        href="https://sailfishos.org/content/uploads/2018/11/48_SAILFISH-APPS-ICON-STORY.pdf"
        target="_blank"
        rel="noopener"
      >
        Harbour icon guidelines (PDF)
      </a>
      <a href="https://codeberg.org/erwanlpfr/harbour-icon-builder" target="_blank" rel="noopener">
        Source code (Codeberg)
      </a>
    </section>
  )
}
